import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,{staticClass:"text-transform-none",attrs:{"color":"#013254","dark":"","height":"34","title":"SINCRONIZAR ALTERAÇÕES FEITAS EM TODAS AS TELAS."},on:{"click":_setup.sincronizar}},[_c(VIcon,{staticClass:"ml-n1 mr-2",attrs:{"size":"25","color":"#EFEFF0"}},[_vm._v("mdi-sync")]),_vm._v("\n  Sincronizar Alterações\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }